/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { GRAPHS } from './graphs'
import { Link } from '@ta-interaktiv/contentbricks'
import { useWindowSize } from './useWindowSize'
// TODO Set the correct article ID here
const ARTICLE_ID = '220373969350'
const TEXT_M = require('../text_de_1.json')
const regexMdLinks = /\[([^[]+)\](\(.*\))/gm

export function AppComponent() {
  const JSXTEXT_M = new Array<[string, JSX.Element[]]>()
  const { isMobile } = useWindowSize()
  TEXT_M.forEach((t: { Q: string; A: { content: string; type: string }[] }) => {
    const Q = t.Q
    const A: JSX.Element[] = []
    t.A.forEach((cont: { content: string; type: string }, i: number) => {
      const matches = cont.content.match(regexMdLinks)

      switch (cont.type) {
        case 'Answer': {
          let links: string[] = []
          const ms = cont.content.match(/\[([^\]]+)\][^)]+\)/g)
          if (matches && ms) {
            links = ms.map(
              (m: string) =>
                m.split('](').map(e => e.replace(/\[|\)/g, '')) as string[]
            )
          }
          let texts = cont.content.split(/\[([^\]]+)\][^)]+\)/g)

          texts = texts.map((m: string, j: number) => {
            const link = links.find(f => f[0] === m)
            if (link)
              return (
                <Link allowWordWrap href={link[1]} key={'l' + j}>
                  {link[0].replace(/^\s+/g, '')}
                </Link>
              )
            return <React.Fragment key={'l' + j}>{m} </React.Fragment>
          })
          A.push(<p key={'a' + i}>{texts}</p>)
          break
        }
        case 'Graph': {
          const graphid = cont.content
            .split('//')
            .join('')
            .split(' | ')[1]
            .replace(/^[ ]+|[ ]+$/g, '')

          A.push(GRAPHS[graphid + ''])
          break
        }
      }
    })
    JSXTEXT_M.push([Q, A])
  })

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className=' headerimage'>
        <div className='ui container '>
          <div className='ui header'>
            <h1>Alles, was Sie jetzt über die Corona-Impfung wissen müssen</h1>
            <h2>
            Wie heftig sind die Nebenwirkungen? Wie lange hält der Schutz? Sind Geimpfte noch ansteckend? Die drängendsten Fragen zur grossen Impfkampagne.
            </h2>
          </div>
        </div>
        <div className='imageholder' />
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
            Alexandra Bröhm, Marc Brupbacher, Nik Walter, Sebastian Broschinski
            </div>
            <div className='ta updated'>Aktualisiert am 12. Mai 2021</div>
          </div>
          <div className='ta text'>
            <p className='intro'>
              Die Corona-Massenimpfung hat in der Schweiz in den letzten Wochen
              so richtig Fahrt aufgenommen. Im April hat der Bund von den beiden
              Herstellern Pfizer/Biontech und Moderna 1,4 Millionen Dosen
              erhalten, im Mai sollen 2 Millionen folgen, im Juni gar über 3
              Millionen. Aktuell wurden bislang über 3,7 Millionen Dosen
              ausgeliefert und gut 3,2 Millionen Dosen verimpft. In vielen
              Kantonen sind die Impfungen bereits für alle Altersgruppen offen.
              Wir beantworten hier die wichtigsten Fragen rund ums Impfen.
            </p>

            {isMobile &&
              JSXTEXT_M.map((m, i) => (
                <AccordionEntry title={m[0]} content={m[1]} key={'b' + i} />
              ))}
            {!isMobile &&
              JSXTEXT_M.map((m, i) => {
                return (
                  <React.Fragment key={'cc' + i}>
                    <h4>{m[0]}</h4>
                    {m[1]}
                  </React.Fragment>
                )
              })}
          </div>
          <iframe
            height='200px'
            width='100%'
            scrolling='no'
            seamless
            src='https://player.simplecast.com/ece60f6c-e68a-4d3b-8f2a-924e1153ecef?dark=true&color=2CA29F'
          ></iframe>
        </div>
      </div>
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Text und Recherche', 'Alexandra Bröhm, Marc Brupbacher, Nik Walter'],
          ['Umsetzung und Illustration', 'Sebastian Broschinski']
        ]}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Umsetzung?'
        ]}
      />
    </div>
  )
}
const AccordionEntry = ({
  title,
  content
}: {
  title: string | JSX.Element
  content: string | JSX.Element | JSX.Element[]
}) => {
  const [showcontent, setShowcontent] = useState(false)
  return (
    <div className='AccordionEntry'>
      <div
        className='titlewrapper'
        onClick={() => {
          setShowcontent(!showcontent)
        }}
      >
        {title && <h4 className='title'>{title}</h4>}

        <div className='indicator'>
          <i className={'icon caret ' + (showcontent ? 'up' : 'down')} />
        </div>
      </div>
      {showcontent && (
        <>{content && <div className='content'>{content}</div>}</>
      )}
    </div>
  )
}
